import { handleActions } from 'redux-actions'
import { setOnSuccess } from 'lp-redux-api'
import { selectorForSlice } from 'lp-redux-utils'
import { serializeLocation, set } from 'utils'
import { createSelector } from 'reselect'
import * as actions from './actions'
import * as Types from 'types'
import * as apiActions from 'api-actions'
import { orderBy } from 'lodash'

const reducerKey = 'teachingArtist'
const slice = 'root.map.teachingArtist'

const initialState = {}

const reducer = handleActions(
  {
    [apiActions.fetchArtist]: setOnSuccess('artist'),
    [actions.clearArtist]: (state) => set('artist', null, state),
    [apiActions.fetchActiveAndPublishedSchoolYears]:
      setOnSuccess('schoolYears'),
  },
  initialState
)

const select = selectorForSlice(slice)

const selectors = {
  artist: select('artist'),
  schoolYears: select('schoolYears'),
}

// Computed
selectors.organizationLocations = createSelector(
  [selectors.artist],
  function (artist) {
    if (!artist || !artist.partnerships) return []

    return artist.partnerships.map(serializeLocation(Types.PARTNER_TYPE))
  }
)

selectors.currentArtistLocation = createSelector(
  [selectors.artist],
  function (artist) {
    if (!artist) return
    return serializeLocation(Types.ARTIST_TYPE, artist)
  }
)

// Order school years by most recent (DESC)
selectors.orderedSchoolYears = createSelector(
  [selectors.schoolYears],
  function (schoolYears) {
    if (!schoolYears) return
    return orderBy(schoolYears, 'number', 'desc')
  }
)

export { reducer, selectors, reducerKey }
